export default "__VITE_ASSET__BMeyCuiX__"